import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import DataSlot from 'components/atoms/DataSlot';
import { Icon } from 'components/atoms/Icon';
import { Row, Col, DropdownToggle } from 'reactstrap';
import Dropdown from 'components/atoms/Dropdown';
import Modal from 'components/atoms/Modal';
import Button from 'components/atoms/Button';

import './MileageSelector.scss';

const ns = 'mileage-selector';

class MileageSelector extends Component {
  constructor(props) {
    super(props);
    this.mileageSelect = this.mileageSelect.bind(this);
    this.continueToSelectMileage = this.continueToSelectMileage.bind(this);
    this.speedBumpModal = React.createRef();
    this.dataSlotsContainer = React.createRef();
    this.state = {
      toggle: true,
      nextMileage: this.props.packageMileages[2],
      gtmSlot: null
    };
  }

  onToggle = () => {
    this.setState({ toggle: !this.state.toggle }, () => {
      const container = this.dataSlotsContainer.current;
      const containerWidth = container.scrollWidth - container.offsetWidth;
      if (!this.state.toggle) {
        this.dataSlotsContainer.current.scrollLeft = containerWidth / 2;
      }
    });
  };

  mileageSelect = mileage => {
    const {
      getPackages,
      clearPackages,
      clearApptServices,
      setExactMileageFlag
    } = this.props;
    if (mileage) {
      clearApptServices();
      clearPackages();
      setExactMileageFlag(1);
      getPackages(mileage);
    }
    this.setState({ toggle: true });
  };

  showSpeedBumpModal = (mileage, slot) => {
    const { hasSelectedServices, selectedPackage, isQuoteAppt } = this.props;
    !isQuoteAppt &&
      this.setState(
        {
          nextMileage: mileage,
          gtmSlot: slot
        },
        () => {
          if (hasSelectedServices || selectedPackage) {
            this.speedBumpModal.current.setShowModal(true);
          } else {
            this.continueToSelectMileage();
          }
        }
      );
  };

  continueToSelectMileage = () => {
    const { nextMileage, gtmSlot } = this.state;
    this.mileageSelect(nextMileage);
    if (gtmSlot) {
      this.trackGtmMileage(nextMileage, gtmSlot);
    } else {
      this.trackGtmMileage(nextMileage);
    }
  };

  getMileageLabel = (months, mileage) => {
    let mileageLabel = '';
    let mileageFormatted;

    if (months) {
      mileageLabel += `${months}mth`;
      if (mileage) {
        mileageLabel += ' / ';
      }
    }
    if (mileage) {
      mileageFormatted = +(mileage / 1000).toFixed(1);
      mileageLabel += `${mileageFormatted}K`;
    }

    return mileageLabel;
  };

  getMileageDataSlots = () => {
    const {
      packageMileages,
      displayMonths,
      packageMonths,
      servicePointFromState,
      isQuoteAppt
    } = this.props;
    const dataSlotsContainerClassName = cn(
      {
        'd-flex': !displayMonths,
        'd-sm-flex': displayMonths
      },
      'justify-content-around',
      `${ns}__data-slot-container`
    );
    let i;
    const dataSlots = [];
    for (i = 0; i < packageMileages.length; i += 1) {
      const mileage = +packageMileages[i];
      const months = displayMonths ? +packageMonths[i] : 0;
      const mileageSlotClassName = cn({
        invisible: !mileage,
        visible: mileage
      });
      dataSlots.push(
        <DataSlot
          key={`data-slot-${i}`}
          disabled={isQuoteAppt}
          onClick={() => {
            if (
              servicePointFromState &&
              servicePointFromState.mileage !== mileage
            ) {
              this.showSpeedBumpModal(mileage, 'data-slot');
            }
          }}
          value={this.getMileageLabel(months, mileage)}
          active={
            servicePointFromState && servicePointFromState.mileage === mileage
          }
          className={mileageSlotClassName}
        />
      );
    }
    return (
      <div
        className={dataSlotsContainerClassName}
        ref={this.dataSlotsContainer}
      >
        {dataSlots}
      </div>
    );
  };

  getSpeedBumpModal() {
    const { intl } = this.props;
    return (
      <div className={'d-flex align-items-center flex-column'}>
        <div className={`${ns}__modal-msg`}>
          {intl.formatMessage({
            id: 'c8.appointment.page.mileage.speedbump.modal.warning'
          })}
        </div>
        <Button
          onClick={() => {
            this.speedBumpModal.current.setShowModal(false);
            this.continueToSelectMileage();
          }}
          className={`${ns}__modal-continue`}
        >
          {intl.formatMessage({
            id: 'c8.common.continue'
          })}
        </Button>
        <Button
          onClick={() => this.speedBumpModal.current.setShowModal(false)}
          buttonTheme={'link'}
          className={`${ns}__modal-cancel`}
        >
          {intl.formatMessage({
            id: 'c8.common.cancel'
          })}
        </Button>
      </div>
    );
  }

  trackGtmMileage(mileage, slot) {
    const { gtmUserEvent } = this.props;
    gtmUserEvent(
      `${slot ? 'Package Mileage Button' : 'Package Mileage arrow Button'}`,
      'Clicked',
      `${mileage ? Math.floor(mileage / 1000) : 0} K Selected`,
      'GTM_CURRENT_PAGE',
      `${mileage}`
    );
  }

  render() {
    const {
      className,
      packageMileages,
      packageMonths,
      displayMonths,
      showMileage,
      intl,
      mileageLabel
    } = this.props;
    const classProps = cn(ns, className, {
      [`${ns}--show-months`]: displayMonths
    });
    const mileageSlotsClassName = cn(
      {
        'd-none': this.state.toggle
      },
      'd-md-block'
    );
    const prevMileage = packageMileages[0];
    const nextMileage = packageMileages[2];
    const iconAriaText = intl.formatMessage({
      id: 'c8.aria.show.more.mileage.options',
      defaultMessage: 'Show more mileage options button'
    });
    return (
      <div className={classProps}>
        <Modal ref={this.speedBumpModal} size="medium">
          {this.getSpeedBumpModal()}
        </Modal>
        <Row className="no-gutters">
          <Col
            xs={displayMonths ? '6' : '10'}
            md={displayMonths ? '3' : '7'}
            lg={displayMonths ? '4' : '7'}
            xl={displayMonths ? '5' : '7'}
          >
            <div className={`${ns}__label`}>
              {intl.formatMessage({
                id: 'c8.services.page.packages.list.label'
              })}
            </div>
          </Col>
          {showMileage && (
            <Col
              xs={displayMonths ? '6' : '2'}
              className="d-md-none text-right"
            >
              <Dropdown className={`${ns}__dropdown`} onClick={this.onToggle}>
                <DropdownToggle caret>
                  {this.getMileageLabel(packageMonths[1], packageMileages[1])}
                  <Icon
                    type="chevron__down"
                    className={`${ns}__dropdown-icon`}
                  />
                </DropdownToggle>
              </Dropdown>
            </Col>
          )}
          {showMileage && (
            <Col
              xs="12"
              md={displayMonths ? '9' : '5'}
              lg={displayMonths ? '8' : '5'}
              xl={displayMonths ? '7' : '5'}
              className={mileageSlotsClassName}
            >
              {mileageLabel &&
                mileageLabel.length > 0 && (
                  <Row className={`${ns}__mileage-services-label`}>
                    <Col>{mileageLabel}</Col>
                  </Row>
                )}
              <Row
                noGutters={true}
                role={'group'}
                aria-label={intl.formatMessage({
                  id: 'c8.aria.mileage.selector',
                  defaultMessage: 'Mileage selector'
                })}
                tabIndex={0}
              >
                {prevMileage ? (
                  <Col
                    tabIndex={0}
                    xs="1"
                    className={`text-center ${ns}__icon-container`}
                    onClick={() => {
                      this.showSpeedBumpModal(prevMileage);
                    }}
                    onKeyUp={event => {
                      if (event.key === 'Enter') {
                        this.showSpeedBumpModal(prevMileage);
                      }
                    }}
                  >
                    <Icon
                      type="chevron__left"
                      className={`${ns}__icon`}
                      aria-label={iconAriaText}
                    />
                  </Col>
                ) : (
                  <Col xs="1" />
                )}
                <Col xs="10">{this.getMileageDataSlots()}</Col>
                <Col
                  tabIndex={0}
                  xs="1"
                  className={`text-center ${ns}__icon-container`}
                  onClick={() => {
                    this.showSpeedBumpModal(nextMileage);
                  }}
                  onKeyUp={event => {
                    if (event.key === 'Enter') {
                      this.showSpeedBumpModal(nextMileage);
                    }
                  }}
                >
                  <Icon
                    type="chevron__right"
                    className={`${ns}__icon`}
                    aria-label={iconAriaText}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

MileageSelector.propTypes = {
  allServicePoints: PropTypes.array,
  className: PropTypes.string,
  clearApptServices: PropTypes.func.isRequired,
  clearPackages: PropTypes.func.isRequired,
  displayMonths: PropTypes.bool.isRequired,
  getPackages: PropTypes.func.isRequired,
  gtmUserEvent: PropTypes.func,
  hasSelectedServices: PropTypes.bool.isRequired,
  intl: PropTypes.object,
  mileageLabel: PropTypes.string,
  packageMileages: PropTypes.array,
  packageMonths: PropTypes.array,
  selectedPackage: PropTypes.object,
  servicePointFromState: PropTypes.object,
  setApptServicePoint: PropTypes.func,
  showMileage: PropTypes.bool.isRequired,
  setExactMileageFlag: PropTypes.func.isRequired,
  isQuoteAppt: PropTypes.bool.isRequired
};

export default MileageSelector;



// WEBPACK FOOTER //
// ./src/components/molecules/MileageSelector/MileageSelector.js